import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.814 3.748c0-.432.354-.748.749-.748h4.367c2.884 0 5.256 2.276 5.256 5.127 0 2.4-1.682 4.393-3.936 4.963l3.842 6.635a.7.7 0 0 1-1.211.701l-4.154-7.173H8.214V20.3a.7.7 0 1 1-1.4 0zm1.4 8.105h3.716c2.149 0 3.857-1.687 3.857-3.726 0-2.04-1.708-3.727-3.857-3.727H8.214z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=CurrencySouthAfricanRandIcon24.js.map